import {
  getLetterOnlyFromNote,
  getOctaveFromNote,
  Note,
  noteToMidi,
} from "app/singing/vocal-driller/constants/notes";
import {
  getNoteFromScaleByDegree,
  getScale,
  ScaleType,
} from "app/singing/vocal-driller/constants/scales";
import Duration from "app/singing/vocal-driller/constants/Duration";
import { LoopStep } from "app/singing/vocal-driller/usePlayer/loopSteps";
import { StaveNoteStruct } from "vexflow";

interface Params {
  loopSteps: LoopStep[];
}

interface Return {
  notes: ExtendedStaveNoteStruct[];
  numOfBeats: number;
}

interface ExtendedStaveNoteStruct extends StaveNoteStruct {
  degrees: number[];
}

const baseNote = Note["c4"];

export default function loopStepsToVexFlow({ loopSteps }: Params): Return {
  const scale = getScale(noteToMidi(baseNote), ScaleType.Major);
  const notes: ExtendedStaveNoteStruct[] = [];
  let numOfBeats = 0;

  function degreeToVexNote(degree: number): string {
    const note = getNoteFromScaleByDegree(scale, degree);
    const letter = getLetterOnlyFromNote(note);
    let octave = getOctaveFromNote(baseNote);

    if (degree === 8) {
      octave += 1;
    }

    return `${letter}/${octave}`;
  }

  loopSteps.forEach((step) => {
    numOfBeats += 1;

    if (step.type === "rest") {
      return;
    }

    // TODO: handle chords
    if (!step.melody) {
      return;
    }

    const degrees = step.melody.degreesToPlay;

    if (!degrees.length) {
      return;
    }

    notes.push({
      degrees,
      keys: degrees.map(degreeToVexNote),
      duration: noteLengthsToVexLength(step.melody.duration),
      dots: step.melody.duration === Duration.dottedHalfNote ? 1 : 0,
    });
  });

  return { notes, numOfBeats };
}

function noteLengthsToVexLength(noteLength: Duration): string {
  switch (noteLength) {
    case Duration.fullNote:
      return "w";
    case Duration.dottedHalfNote:
    case Duration.halfNote:
      return "h";
    case Duration.quarterNote:
      return "q";
    case Duration.eighthNote:
      return "8";
  }

  throw new Error(`Invalid note length ${noteLength}`);
}
